import React from 'react';

import styles from './GridDebug.module.css';

/**
 * Development-only overlay that renders the grid column tracks.
 *
 * Renders a `position: fixed` overlay showing:
 * - Teal column tracks — the 12 (desktop), 8 (tablet), or 4 (mobile) columns
 * - Pink outer margin — the area outside the page column (1128px of content plus padding)
 * - Transparent gaps — the gutters between columns (16px mobile/tablet, 24px desktop), so content shows through
 *
 * Place at the root of your layout during development and remove before committing:
 *
 * @example
 * {process.env.NODE_ENV === 'development' && <GridDebug />}
 *
 * The overlay is non-interactive (`pointer-events: none`) so it does not block
 * clicks or keyboard navigation while it is visible.
 */
const GridDebug = () => (
    <div
        className={styles.overlay}
        aria-hidden="true"
    >
        <div className={styles.marginLeft} />
        <div className={styles.inner}>
            <div className={styles.grid}>
                {Array.from({ length: 12 }, (_, i) => (
                    <div
                        key={i}
                        className={styles.col}
                    />
                ))}
            </div>
        </div>
        <div className={styles.marginRight} />
    </div>
);

GridDebug.displayName = 'GridDebug';

export default GridDebug;
